import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (event.detail.data.clientOptimistic && event.detail.resource) {
      const inventoryIcon = this.querySelector('.product-inventory__icon');
      const inventoryText = this.querySelector('.product-inventory__text');
      if (!(inventoryIcon instanceof HTMLElement) || !(inventoryText instanceof HTMLElement)) return;

      const threshold = Number(this.dataset.inventoryThreshold || 0);
      const showQuantity = this.dataset.showQuantity === 'true';
      const inventoryManaged = event.detail.resource.inventory_management === 'shopify';
      const inventoryQuantity = Number(event.detail.resource.inventory_quantity || 0);
      const inventoryPolicy = event.detail.resource.inventory_policy;

      let status = 'out_of_stock';
      let text = this.dataset.textOutOfStock || 'Out of stock';

      if (inventoryManaged) {
        if (inventoryQuantity > 0) {
          if (inventoryQuantity <= threshold) {
            status = 'low';
            text = showQuantity
              ? (this.dataset.textLowStockCount || '__count__ left').replace('__count__', String(inventoryQuantity))
              : this.dataset.textLowStock || 'Low stock';
          } else {
            status = 'in_stock';
            text = this.dataset.textInStock || 'In stock';
          }
        } else if (inventoryPolicy === 'continue') {
          status = 'in_stock';
          text = this.dataset.textInStock || 'In stock';
        }
      } else if (event.detail.resource) {
        status = 'in_stock';
        text = this.dataset.textInStock || 'In stock';
      }

      inventoryIcon.classList.remove(
        'product-inventory__icon-low',
        'product-inventory__icon-in_stock',
        'product-inventory__icon-out_of_stock'
      );
      inventoryIcon.classList.add(`product-inventory__icon-${status}`);
      inventoryText.textContent = text;
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
